import Axios from "../helper/axios";
import { urls } from "../constants/constants";

const axios = new Axios();

export default class BroadcastUserService {
  getUploadStatus() {
    const option = {
      url: `${urls.aspariaBackend}api/v1/broadcast/getUploadStatus`,
    };

    return axios.get(option);
  }
  getTemplatesByPracticeId(practiceId) {
    const option = {
      url: `${
        urls.aspariaBackend
      }api/v1/contentTemplate/practiceId/${practiceId}`,
    };
    return axios.get(option);
  }
  messageLogs(message) {
    const option = {
      url: `${urls.aspariaBackend}api/v1/logs/message`,
      data: message,
    };
    return axios.post(option);
  }

  translationOfMessage(data) {
    const option = {
      url: `${urls.aspariaBackend}api/v1/broadcast/translationOfMessage`,
      data,
    };
    return axios.post(option);
  }

  getBroadcastData(data) {
    const option = {
      url: `${urls.aspariaBackend}api/v1/broadcast/list/${data}`,
    };

    return axios.get(option);
  }

  downloadBroadcastFile(data, modality) {
    const option = {
      url: `${
        urls.aspariaBackend
      }api/v1/broadcast/reportFileList/${data}?modality=${modality}`,
    };

    return axios.get(option);
  }

  getStatusList(params) {
    const option = {
      url: `${
        urls.aspariaBackend
      }api/v1/pe/appointments/calendar/suggestions/status`,
      params: {
        practiceId: params,
      },
    };
    return axios.get(option);
  }

  getSuggestionsEmployee = (column, value) => {
    const option = {
      url: `${
        urls.aspariaBackend
      }api/v1/broadcasts/columnData/employee?attribute=${column}&value=%${value}%`,
    };
    return axios.get(option);
  };

  getSuggestionsPatient = (column, value) => {
    const option = {
      url: `${
        urls.aspariaBackend
      }api/v1/broadcasts/columnData/patient?attribute=${column}&value=%${value}%`,
    };
    return axios.get(option);
  };

  getSuggestionsAppointment = (column, value) => {
    const option = {
      url: `${
        urls.aspariaBackend
      }api/v1/broadcasts/columnData/apiPatient?attribute=${column}&value=%${value}%`,
    };
    return axios.get(option);
  };

  getEmployeeList = (fileId) => {
    const option = {
      url: `${
        urls.aspariaBackend
      }api/v1/broadcast/employeeSendAnotherMessage?fileId=${fileId}`,
    };
    return axios.get(option);
  };

  getSavedFileContent = (file, userType, isMultiLang = false) => {
    const isMultiLangStr = isMultiLang ? "true" : "false";
    const option = {
      url: `${
        urls.aspariaBackend
      }api/v1/broadcasts/getSavedFileContent/${userType}?fileNickName=${file}&size=15&pageNo=1&isMultiLang=${isMultiLangStr}`,
    };
    return axios.get(option);
  };

  updateUnsentRecords = (fileId) => {
    const option = {
      url: `${
        urls.aspariaBackend
      }api/v1/broadcast/updateUnsentRecords?fileId=${fileId}`,
    };
    return axios.get(option);
  };

  getSavedBroadcastFiles = (userType, page) => {
    const option = {
      url: `${
        urls.aspariaBackend
      }api/v1/broadcast/getSavedBroadcastFiles/${userType}?size=5&pageNo=${page}`,
    };
    return axios.get(option);
  };

  updateSavedFileName = (data, userType) => {
    const option = {
      url: `${
        urls.aspariaBackend
      }api/v1/broadcast/updateSavedFileName/${userType}`,
      data: data,
    };
    return axios.put(option);
  };

  deleteFile = (data) => {
    const option = {
      url: `${urls.aspariaBackend}api/v1/broadcast/deleteSavedFile/${
        data.userType
      }?fileNickName=${data.fileNickName}`,
    };
    return axios.delete(option);
  };

  deleteRecords = (userType, data) => {
    const option = {
      url: `${
        urls.aspariaBackend
      }api/v1/broadcast/removeSavedFileRecords/${userType}`,
      data: data,
    };
    return axios.put(option);
  };

  getSuggestionsPreview = (fileId, column, value) => {
    const option = {
      url: `${
        urls.aspariaBackend
      }api/v1/broadcast/previewFileColumnsData/${fileId}?attribute=${column}&value=%${value}%`,
    };
    return axios.get(option);
  };

  getMessageLogs = (
    pageNo = 1,
    pageSize = 15,
    sort = "",
    filter = "",
    startDate = "",
    endDate = ""
  ) => {
    const option = {
      url: `${
        urls.aspariaBackend
      }api/v1/broadcastAnalytics/getBroadcastMessageLog?pageNo=${pageNo}&pageSize=${pageSize}${
        sort ? `&sort=${sort}` : ""
      }${filter ? `&filter=${filter}` : ""}${
        startDate ? `&startDate=${startDate}` : ""
      }${endDate ? `&endDate=${endDate}` : ""}`,
    };
    return axios.get(option);
  };

  getLogsListSuggestions(
    column,
    value,
    filters = {},
    startDate = "",
    endDate = ""
  ) {
    const option = {
      url: `${
        urls.aspariaBackend
      }api/v1/broadcastAnalytics/columnData?attribute=${column}&value=${value}&filter=${JSON.stringify(
        filters
      )}${startDate ? `&startDate=${startDate}` : ""}${
        endDate ? `&endDate=${endDate}` : ""
      }`,
    };
    return axios.get(option);
  }

  getBroadcastAuditLogs(
    pageNo = 1,
    pageSize = 15,
    sort = "",
    filter = "",
    startDate = "",
    endDate = "",
    csv = false
  ) {
    const option = {
      url: `${
        urls.aspariaBackend
      }api/v1/broadcastAudit/getlogs?page=${pageNo}&size=${pageSize}${
        sort ? `&sort=${sort}` : ""
      }${filter ? `&filter=${filter}` : ""}${
        startDate ? `&startDate=${startDate}` : ""
      }${endDate ? `&endDate=${endDate}` : ""}${csv ? `&csv=${csv}` : ""}`,
    };
    return axios.get(option);
  }

  async downloadXlsx(
    pageNo = 1,
    pageSize = 15,
    sort = "",
    filter = "",
    startDate = "",
    endDate = "",
    csv = false
  ) {
    return await axios.get({
      url: `${
        urls.aspariaBackend
      }api/v1/broadcastAudit/getlogs?page=${pageNo}&size=${pageSize}${
        sort ? `&sort=${sort}` : ""
      }${filter ? `&filter=${filter}` : ""}${
        startDate ? `&startDate=${startDate}` : ""
      }${endDate ? `&endDate=${endDate}` : ""}${csv ? `&csv=${csv}` : ""}`,
      method: "GET",
      responseType: "blob",
    });
  }

  getBroadcastAuditSuggestions(
    column,
    value,
    filters = {},
    startDate = "",
    endDate = ""
  ) {
    const option = {
      url: `${
        urls.aspariaBackend
      }api/v1/broadcastAudit/columnData?attribute=${column}&value=${value}&filter=${JSON.stringify(
        filters
      )}${startDate ? `&startDate=${startDate}` : ""}${
        endDate ? `&endDate=${endDate}` : ""
      }`,
    };
    return axios.get(option);
  }

  getThrottleConfig() {
    const option = {
      url: `${urls.aspariaBackend}api/v1/throttle-configs/live-chat`,
    };
    return axios.get(option);
  }

  updateThrottleConfig(id, data) {
    const option = {
      url: `${urls.aspariaBackend}api/v1/throttle-configs/${id}`,
      data: data,
    };
    return axios.put(option);
  }
}
